// PhytoPūr Bio
export const PHYTOPUR_STRAINS = [
  {
    id: "phytopur-frosted-lemon-angel",
    name: "Frosted Lemon Angel",
    producer: "PhytoPūr Bio",
    country: "Dania",
    genetics: "Hybryda/Indica",
    lineage: "Lemon Skunk × Kosher Kush",
    thc: 24, cbd: 1.0,
    availability: "Wysoka", effect: "Zrównoważone",
    aromas: ["Cytrusowy", "Korzenny", "Miętowy", "Ziołowy"],
    description: "Frosted Lemon Angel to hybryda z lekką przewagą indici (60/40), powstała z połączenia Lemon Skunk i Kosher Kush. Dominujący kariofilen zapewnia silne działanie przeciwzapalne oraz działa przeciwbólowo, co wzmacnia dodatkowo humulen. Mircen pogłębia fizyczne odprężenie i relaksację mięśniową. Odmiana łączy umysłowe pobudzenie z postępującym relaksem ciała — początkowo działa aktywizująco, a następnie przynosi głębokie wyciszenie. Pacjenci zgłaszają głębokie odprężenie i wyciszenie, a następnie poprawę jakości snu.",
    terpenes: { kariofilen: 41, mircen: 17, limonen: 13, humulen: 12, terpinolen: 10, pinen: 4, bisabolol: 2 },
    dominantTerpene: "Kariofilen", packaging: "10g"
  },
  {
    id: "phytopur-gorilla-glue",
    name: "Gorilla Glue",
    producer: "PhytoPūr Bio",
    country: "USA",
    genetics: "Hybryda/Indica",
    lineage: "Chem Sis × Sour Dubb × Chocolate Diesel",
    thc: 24, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Ziemisty", "Drzewny", "Korzenny"],
    description: "Gorilla Glue od PhytoPūr Bio to hybryda/indica (60:40) o THC 24%. Dominujący kariofilen zapewnia silne działanie przeciwzapalne i przeciwbólowe poprzez bezpośrednią aktywację receptorów CB2. Limonen wnosi cytrusową świeżość i wspiera poprawę nastroju, a bisabolol i linalol dopełniają profil właściwościami uspokajającymi.",
    terpenes: { kariofilen: 49, limonen: 13, terpinolen: 10, bisabolol: 7, linalol: 4, mircen: 3, pinen: 2 },
    dominantTerpene: "Kariofilen", packaging: "10g"
  },
  {
    id: "phytopur-big-purple-dragon",
    name: "Big Purple Dragon",
    producer: "PhytoPūr Bio",
    country: "USA",
    genetics: "Hybryda",
    lineage: "nieznany rodowód",
    thc: 24, cbd: 1.0,
    availability: "Wysoka", effect: "Zrównoważone",
    aromas: ["Pieprzowy", "Pikantny", "Ziemisty", "Ziołowy"],
    description: "Bogaty profil terpenowy powoduje początkowe pobudzenie umysłowe, przechodzące następnie w rozluźnienie i relaks, a wysokie stężenie THC i dominacja kariofilenu gwarantują działanie przeciwbólowe i przeciwzapalne.",
    terpenes: { kariofilen: 43, humulen: 8, pinen: 4, mircen: 13, linalol: 4, farnezen: 1, guaiol: 13, limonen: 13 },
    dominantTerpene: "Kariofilen", packaging: "10g"
  }
];